module.exports = __webpack_public_path__ + "media/images/lp/img_voice_01-9ac4ec9350cb6d28739911e1dff81e34.png";